import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiInstagram, FiFacebook, FiLinkedin, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer id="contact" className="bg-primary text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Col */}
          <div>
            <div className="text-2xl font-serif font-bold text-white mb-6">
              Arvind<span className="text-accent">Interiors</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Creating timeless, elegant, and functional spaces tailored to your unique lifestyle. We bring your vision to life with precision and passion.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-accent transition-colors"><SafeIcon icon={FiInstagram} className="h-5 w-5" /></a>
              <a href="#" className="text-gray-400 hover:text-accent transition-colors"><SafeIcon icon={FiFacebook} className="h-5 w-5" /></a>
              <a href="#" className="text-gray-400 hover:text-accent transition-colors"><SafeIcon icon={FiLinkedin} className="h-5 w-5" /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'About Us', 'Services', 'Portfolio', 'Contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item.toLowerCase().replace(' ', '')}`} className="text-gray-400 hover:text-accent transition-colors text-sm">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {['Residential Design', 'Commercial Spaces', 'Space Planning', 'Custom Furniture', 'Renovation'].map((item) => (
                <li key={item}>
                  <span className="text-gray-400 text-sm cursor-default">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-serif font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiMapPin} className="h-5 w-5 text-accent flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">Spectrum Mall, Sector 75, Noida</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="h-5 w-5 text-accent flex-shrink-0" />
                <span className="text-gray-400 text-sm">+91 9958450546</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="h-5 w-5 text-accent flex-shrink-0" />
                <span className="text-gray-400 text-sm">hello@arvindinteriors.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Arvind Interiors. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500">
            <a href="#" className="hover:text-accent transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-accent transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;